<template>
  <main class="card mt-5">
    <div class="card-header border-0">
      <h5 class="card-title font-bold">
        {{ mode == "create" ? "محصول جدید" : "اطلاعات محصول" }}
      </h5>
    </div>
    <div class="card-body">
      <BForm @submit.prevent="submitHandler">
        <InputGroup label="نام محصول" required>
          <b-form-input
            type="text"
            v-model="product.title"
            placeholder="نام محصول"
          />
        </InputGroup>
        <InputGroup label="قیمت واحد" required>
          <b-form-input
            :value="product.price | priceinput"
            type="text"
            placeholder="قیمت واحد"
            @keydown="filterDigits"
            @input="
              (value) => {
                product.price = value !== '' ? +value.replace(/\D/g, '') : '';
              }
            "
          />
        </InputGroup>
        <InputGroup label="قیمت خرید" required>
          <b-form-input
            :value="product.purchase_price | priceinput"
            type="text"
            placeholder="قیمت خرید"
            @keydown="filterDigits"
            @input="
              (value) => {
                product.purchase_price =
                  value !== '' ? +value.replace(/\D/g, '') : '';
              }
            "
          />
        </InputGroup>
        <InputGroup label="تخفیف">
          <treeselect
            class="mb-3"
            :options="discountOptions"
            noResultsText="موردی یافت نشد"
            v-model="product.discount_type"
            :multiple="false"
            noOptionsText="موردی وجود ندارد"
            placeholder="تخفیف"
            @select="changeDiscountOption"
          ></treeselect>
          <b-form-input
            class="mb-3"
            v-if="product.discount_type === 'flat'"
            :value="product.discount | priceinput"
            @input="
              (value) => {
                product.discount =
                  value !== '' ? +value.replace(/\D/g, '') : '';
              }
            "
            type="text"
            placeholder="قیمت"
          />
          <b-form-input
            class="mb-3"
            v-else-if="product.discount_type === 'percentage'"
            min="1"
            max="100"
            @change="discountChanged"
            v-model="product.discount"
            type="number"
            placeholder="درصد تخفیف"
          />
          <date-picker
            v-if="product.discount_type != ''"
            type="datetime"
            v-model="product.discount_until"
            format="YYYY-MM-DD HH:mm:ss"
            display-format="jYYYY/jMM/jDD HH:mm"
            color="#3366ff"
          />
        </InputGroup>
        <InputGroup label="توضیحات">
          <b-form-textarea
            placeholder="توضیحات"
            v-model="product.short_description"
            rows="4"
          ></b-form-textarea>
        </InputGroup>
        <InputGroup label="وضعیت">
          <treeselect
            :multiple="false"
            :options="statusOptions"
            noChildrenText="فرزندی وجود ندارد"
            noOptionsText="موردی وجود ندارد"
            noResultsText="موردی یافت نشد"
            placeholder="انتخاب وضعیت"
            v-model="product.status"
          ></treeselect>
        </InputGroup>
        <InputGroup label="تصویر شاخص" required>
          <b-form-file
            v-model="product.main_image"
            id="mainImageFile"
            class="d-none"
          >
          </b-form-file>
          <div class="border rounded bg-white p-4">
            <label class="btn btn-primary" for="mainImageFile"
              >افزودن عکس</label
            >
            <img
              class="d-flex mt-3"
              width="150"
              height="150"
              v-if="product.main_image && product.main_image.id"
              :src="product.main_image.original_url"
              alt="main image"
            />

            <img
              class="d-flex mt-3"
              width="150"
              height="150"
              v-else-if="product.main_image"
              :src="getImage"
              alt="main image"
            />
          </div>
        </InputGroup>
        <InputGroup label="تصاویر">
          <ProductImages
            @addToDeletedList="addToDeletedList"
            v-model="product.images"
          />
        </InputGroup>
        <InputGroup label="عنوان متا">
          <b-form-input
            v-model="product.meta_title"
            type="text"
            placeholder="عنوان متا"
          />
        </InputGroup>
        <InputGroup label="توضیحات متا">
          <b-form-textarea
            placeholder="توضیحات متا"
            v-model="product.meta_description"
            rows="4"
          ></b-form-textarea>
        </InputGroup>
        <BButton type="submit" variant="success">ثبت</BButton>
      </BForm>
    </div>
  </main>
</template>

<script>
import ProductCreateEditImpl from "@@/core/pages/product/ProductCreateEdit/ProductCreateEditImpl.js";
export default {
  extends: ProductCreateEditImpl,
};
</script>
